import { useBotbPassDrawerContext } from "./botb-pass-drawer-context";
import Subscription from "./subscription";
import React, { useEffect } from "react";
import DrawerWrapper from "./drawer-wrapper";
import CloseModalIcon from "../../shared-components/icons/CloseModalIcon";
import Skeleton from "react-loading-skeleton";
import { publishModalVisibility } from "../../redux/features/modal/modalSlice";
import { useAppDispatch } from "../../redux/hooks";

export const BotbPassDrawerContent = () => {
  const dispatch = useAppDispatch();
  const {
    allPackages,
    setIsDrawerOpen,
    isDrawerOpen,
    onClickClose,
    shouldShowDrawer,
    preSubscriptionData,
    closeModal,
    preSubscriptionDataLoading,
  } = useBotbPassDrawerContext();

  useEffect(() => {
    if (isDrawerOpen) {
      document.querySelector("body").classList.add("is-drawer-open");
    } else {
      document.querySelector("body").classList.remove("is-drawer-open");
    }

    return () => {
      document.querySelector("body").classList.remove("is-drawer-open");
    };
  }, [isDrawerOpen]);

  if (!shouldShowDrawer) {
    return null;
  }

  if (preSubscriptionDataLoading) {
    return (
      <Skeleton
        count={1}
        inline
        highlightColor="#fff"
        containerClassName="flex flex-col w-full h-[500px]"
        className="h-full"
      />
    );
  }

  return (
    <>
      <div data-name="Overlay" className={`fixed inset-0 z-[9999] bg-black/80 ${isDrawerOpen ? " " : "hidden"}`} />

      <div
        className={`subscription-overlay fixed inset-x-0 !bottom-20 !top-auto lg:hidden ${isDrawerOpen ? "z-[10000]" : "z-[11]"}`}>
        {/*START MOBILE*/}
        <div className={"max-lg:relative pt-12 bg-white rounded-t-2xl max-lg:shadow-[0_0_20px_0_rgba(0,0,0,0.08)]"}>
          {/*FIXED TOP*/}
          <div className={"h-12 w-full absolute z-20 inset-x-0 top-0 px-3 lg:hidden"}>
            <div
              className={`w-full py-2 flex items-center gap-[18px] ${isDrawerOpen ? "border-b border-b-black/8" : ""}`}>
              <div onClick={onClickClose} className={"text-[#6679B3] text-xs font-medium leading-4"}>
                Close
              </div>
              <div className={"flex items-center gap-2.5"}>
                <div>
                  <img
                    src={"/assets/images/botb-pass/house-competition-drawer.webp"}
                    alt={"cars-only"}
                    width={138}
                    height={56}
                    className={"h-7 w-auto"}
                  />
                </div>
                <div className={"text-gray-1 text-xs font-medium leading-4 font-jost max-w-40"}>
                  Subscribe and save up to 75% with BOTB Pass
                </div>
              </div>
              <div
                onClick={() => {
                  setIsDrawerOpen(prevState => !prevState);
                  dispatch(publishModalVisibility({ isOpen: false }));
                }}
                className={"ml-auto bg-gray-6 rounded-full size-8 flex-center"}>
                <div className={`${isDrawerOpen ? "rotate-180" : "rotate-0"}`}>
                  <svg
                    className={"w-3 h-1.5"}
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="8"
                    viewBox="0 0 14 8"
                    fill="none">
                    <path
                      d="M1 7L7 1L13 7"
                      stroke="#898994"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out lg:hidden ${
              isDrawerOpen ? "drawer-max-height opacity-100" : "max-h-0 opacity-0"
            }`}>
            <div className={"overflow-y-auto drawer-max-height py-4 pb-11 px-4"}>
              <DrawerWrapper>
                {allPackages.map(_package => (
                  <Subscription key={_package.productId} subscriptionPackage={_package} />
                ))}
              </DrawerWrapper>
            </div>
          </div>
          {/*DESKTOP CONTENT*/}
        </div>
        {/*END MOBILE*/}
      </div>

      {/*-------------------------------------------------------------------------------------------------*/}
      {/*-------------------------------------------------------------------------------------------------*/}
      {/*-------------------------------------------------------------------------------------------------*/}
      {/*-------------------------------------------------------------------------------------------------*/}

      {isDrawerOpen && (
        <div
          data-name="PopupContainer"
          className={"max-lg:hidden fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
          <div className={"max-lg:hidden w-full min-h-full flex items-center justify-center flex-col m-auto lg:p-6"}>
            <div
              className={
                "max-lg:hidden bg-white relative w-full lg:max-w-[1144px] lg:min-h-[665px] pt-10 pb-6 px-14 flex flex-col max-lg:grow rounded-t-[20px] lg:rounded-2xl"
              }>
              <button
                onClick={closeModal}
                className={
                  "max-lg:hidden absolute flex items-center justify-center right-3 top-3 lg:right-2 lg:top-2 lg:size-10"
                }>
                <CloseModalIcon className={"size-6 text-gray-5"} />
              </button>

              {/*START DESKTOP*/}
              <DrawerWrapper>
                {allPackages.map(_package => (
                  <Subscription key={_package.productId} subscriptionPackage={_package} />
                ))}
              </DrawerWrapper>
              {/*END DESKTOP*/}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
